import { Component, Input, OnInit } from '@angular/core';
import { Form } from '../../_forms';
import { AlertService } from '../../_services';
import { Router } from '@angular/router';
import { Location } from '@angular/common';
import { ContactFormField, EmailSupportFieldTypes } from '../../_models';
import { FormBuilder, Validators } from '@angular/forms';

@Component({
  templateUrl: './contact-field-popup.component.html',
  selector: 'app-contact-field-popup',
})
export class ContactFieldPopupComponent extends Form implements OnInit {
  @Input('field') field: ContactFormField = null;
  @Input('fieldTypeOptions') fieldTypeOptions: any[] = [];
  @Input('isEditableField') isEditableField: boolean = true;
  emailSupportFieldTypes = EmailSupportFieldTypes;

  constructor(
    protected alertService: AlertService,
    protected router: Router,
    protected location: Location,
    protected formBuilder: FormBuilder
  ) {
    super(alertService, router, location);
  }

  ngOnInit() {
    this.form = this.formBuilder.group({
      name: [null, Validators.required],
      label: [null, [Validators.required]],
      type: [EmailSupportFieldTypes.Text, [Validators.required]],
      values: [null],
      required: [null],
    });
    super.ngOnInit();

    if (this.field) {
      this.form.patchValue(this.field);
      this.updateValuesControl();
    }

    if (!this.isEditableField) {
      this.form.get('name').disable();
      this.form.get('type').disable();
      this.form.get('required').disable();
    }

    this.form.get('type').valueChanges.subscribe(() => {
      this.updateValuesControl();
    });
  }

  updateValuesControl() {
    const valuesControl = this.form.get('values');
    if (this.form.get('type').value === EmailSupportFieldTypes.Select) {
      valuesControl.setValidators(Validators.required);
    } else {
      valuesControl.setValue(null);
      valuesControl.clearValidators();
    }
    valuesControl.updateValueAndValidity();
  }

  getFormData() {
    if (this.form.valid) {
      return this.form.value as ContactFormField;
    }

    return null;
  }
}
